export default __webpack_public_path__ + "static/media/loans.bf255fa2.svg";